import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "turn-off-developer-mode"
    }}>{`Turn off Developer Mode`}</h2>
    <p>{`By default, Cezerin is in developer mode. This means you can access API and
Dashboard without authorization (access tokens).`}</p>
    <p>{`Don't forget to switch off developer mode at working store. At dev mode api's
and dashboard available for all without any restrictions.`}</p>
    <p>{`To turn off developer mode, you need to do:`}</p>
    <ul>
      <li parentName="ul">{`Add access token while install (npm run setup ...) or add email for admin at
Admin - Settings - Web tokens`}</li>
      <li parentName="ul">{`Set SMTP server in `}<inlineCode parentName="li">{`cezerin2/config/server.js`}</inlineCode></li>
      <li parentName="ul">{`Set false for option `}<inlineCode parentName="li">{`developerMode`}</inlineCode>{` from `}<inlineCode parentName="li">{`cezerin2/config/server.js`}</inlineCode></li>
      <li parentName="ul">{`Set false for option `}<inlineCode parentName="li">{`developerMode`}</inlineCode>{` from `}<inlineCode parentName="li">{`cezerin2/config/admin.js`}</inlineCode></li>
      <li parentName="ul">{`Rebuild & restart apps with new configs:`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`npm run build
pm2 reload api
pm2 reload store
`}</code></pre>
    <ul>
      <li parentName="ul">{`Production mode is active now.`}</li>
    </ul>
    <p>{`What is production mode?!`}</p>
    <p>{`At production mode all requests to api must be authorized with JWT token.`}</p>
    <p>{`It means nobody can add/edit/delete categories, products, orders, customers,
etc. without permission.`}</p>
    <p>{`Only admins can make this.`}</p>
    <p>{`You must login before you access to admin. Login page -
`}<a parentName="p" {...{
        "href": "https://your-domain-name.com/admin/login"
      }}>{`https://your-domain-name.com/admin/login`}</a></p>
    <p>{`Specify your admin email address and you will receive email with authorization
link.`}</p>
    <p>{`Click to link at email and you will set JWT token at all requests to api.`}</p>
    <p>{`JWT token added to every request header - Bearer Authentication.`}</p>
    <p>{`P.S. or you can manually login to the admin, without email.`}</p>
    <p>{`Add admin JWT key at Admin - Settings - Personal access tokens.`}</p>
    <p>{`Save your key.`}</p>
    <p>{`JWT Token looks like this:`}</p>
    <p>{`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZXMiOlsiYWRtaW4iXSwianRpIjoiNWUyY2FhODU2MjEyMmYwZjQwODdkNmUyIiwiZW1haWwiOiJ2YW1zaG9wQGdtYWlsLmNvbSIsImlhdCI6MTU3OTk4NTk1MCwiZXhwIjo0MTcxOTg1OTUwfQ.28iql8r_PDARK6Xym2JWWkV3Vk7cBBkMbALbhEyA2oI`}</p>
    <p>{`Switch to production mode.`}</p>
    <p>{`And authorizate to admin with this url example:
`}<a parentName="p" {...{
        "href": "https://your-domain-name.com/admin/login?token="
      }}>{`https://your-domain-name.com/admin/login?token=`}</a></p>
    <p>{`Insert you key in the URL, like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://your-domain-name.com/admin/login?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZXMiOlsiYWRtaW4iXSwianRpIjoiNWUyY2FhODU2MjEyMmYwZjQwODdkNmUyIiwiZW1haWwiOiJ2YW1zaG9wQGdtYWlsLmNvbSIsImlhdCI6MTU3OTk4NTk1MCwiZXhwIjo0MTcxOTg1OTUwfQ.28iql8r_PDARK6Xym2JWWkV3Vk7cBBkMbALbhEyA2oI"
      }}>{`https://your-domain-name.com/admin/login?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZXMiOlsiYWRtaW4iXSwianRpIjoiNWUyY2FhODU2MjEyMmYwZjQwODdkNmUyIiwiZW1haWwiOiJ2YW1zaG9wQGdtYWlsLmNvbSIsImlhdCI6MTU3OTk4NTk1MCwiZXhwIjo0MTcxOTg1OTUwfQ.28iql8r_PDARK6Xym2JWWkV3Vk7cBBkMbALbhEyA2oI`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      